import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { useReveal } from "../lib/useReveal";

/**
 * Top-level layout: header → page content → footer.
 * Scroll resets on route change so SPA navigation matches the multi-page feel.
 */
export function Layout() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    // A hash aims the link at a section rather than the top of the page — the
    // home page's programme cards deep-link into /academics that way. Without
    // this the scroll-reset below would land every one of them at the top.
    // Positioning under the sticky header is left to the target's own
    // scroll-margin-top (see `.page-content [id]`), and the jump is explicitly
    // instant: html sets scroll-behavior:smooth, which would otherwise animate
    // the full height of the page on a cross-page navigation.
    if (hash) {
      const el = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (el) {
        el.scrollIntoView({ behavior: "auto" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  useReveal();

  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}
